import actionTypes from '../actionTypes';

export function openDialog( view, params ) {
  return {
    type: actionTypes.OPEN_DIALOG,
    view,
    params
  }
}

export function closeDialog( view ) {
  return {
    type: actionTypes.CLOSE_DIALOG
  }
}
